/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'cluster-node';

export const clusterNodeBreadcrumbTitle = `${prefix}.clusterNodeBreadcrumbTitle`;

export const ENGLISH = {
    [clusterNodeBreadcrumbTitle]: 'Cluster Node',
};
